import { Injectable } from '@angular/core'

@Injectable()
export class OverlayService {
   public isVisible: boolean = false

   public toggle(): void {
      this.isVisible = !this.isVisible
   }
}